import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BasketItem } from '@sabstravtech/obtservices/angular';

@Component({
  selector: 'app-basket-hotel',
  templateUrl: './basket-hotel.component.html',
  styleUrls: ['./basket-hotel.component.scss'],
  standalone: false
})
export class BasketHotelComponent implements OnInit {
  @Input() hotel: BasketItem;
  @Input() duplicateBooking = false;
  @Output() remove: EventEmitter<void> = new EventEmitter<void>();
  @Output() openChangeModal: EventEmitter<void> = new EventEmitter<void>();
  @Input() displayItinerary = false;

  travellers = [];

  constructor() {}

  ngOnInit(): void {
    this.travellers = [...(this.hotel?.users || []), ...(this.hotel?.guests || [])];
  }

  getHotelAddress(): string {
    const { county, postcode, streetName, town } = this.hotel?.detail?.hotelAddress;
    const hotelAddressArr = [];
    if (streetName) {
      hotelAddressArr.push(streetName);
    }
    if (town) {
      hotelAddressArr.push(town);
    }
    if (county) {
      hotelAddressArr.push(county);
    }
    if (postcode) {
      hotelAddressArr.push(postcode);
    }
    return hotelAddressArr.join(', ');
  }
}
